// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";

import { CssVarsProvider, StyledEngineProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import { BrowserRouter } from "react-router-dom";

import "./index.css";

import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

import { AuthProvider } from "./context/AuthContext";
import { ModalProvider } from "./context/ModalContext";
import { ToastProvider } from "./context/ToastContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <StyledEngineProvider injectFirst>
        <CssVarsProvider disableTransitionOnChange>
          <CssBaseline />
          <AuthProvider>
              <BrowserRouter>
                <ToastProvider>
                  <ModalProvider>
                    <App />
                  </ModalProvider>
                </ToastProvider>
              </BrowserRouter>
          </AuthProvider>
        </CssVarsProvider>
      </StyledEngineProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
